import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-project-popup',
  templateUrl: './about-project-popup.component.html',
  styleUrls: ['./about-project-popup.component.scss']
})
export class AboutProjectPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
